import { tv as t } from "../tailwind-variants.config.js";
const e = t({
  base: "",
  variants: {
    size: {
      sm: "jm-w-4 jm-h-4",
      md: "jm-w-6 jm-h-6",
      lg: "jm-w-8 jm-h-8"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), m = t({
  extend: e,
  variants: {
    size: {
      xs: "w-2 h-2"
    }
  }
});
export {
  m as getChevronIconStyles,
  e as getIconStyles
};
//# sourceMappingURL=styles.js.map
